// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","main-color":"var(--main-color)","root":"_2iZ6nJF","input_root":"_3X2ZtZ-","shrink":"_1YPbCn9","listbox":"_2dnr1Ug"};